export enum MessageType {
  USER = "USER",
  SPACE = "SPACE",
  SYSTEM = "SYSTEM",
}

/* SEND MESSAGE TO GRAPHIC CLIENT */

export enum UserSendMessageType {
  UPDATE_USER = "UPDATE_USER",
  SEND_PAPER_PLANE = "SEND_PAPER_PLANE_USER",
  SEND_BIRTHDAY_COKE = "SEND_BIRTHDAY_COKE",
  USER_CONNECTED = "USER_CONNECTED_USER",
  USER_DISCONNECTED = "USER_DISCONNECTED_USER",
  USER_VACATION_OFF = "USER_VACATION_OFF",
  USER_VACATION_ON = "USER_VACATION_ON",
  USER_DISABLE = "USER_DISABLE",
  CALL_ONE_TO_ONE_OK = "CALL_ONE_TO_ONE_OK",
  SET_TIMEZONE_UTC_OFFSET = "SET_TIMEZONE_UTC_OFFSET",
  EMOJI_REACTION = "EMOJI_REACTION",
  MOVE_LOCAL_USER = "MOVE_LOCAL_USER",
  MOVE_LOCAL_USER_START = "MOVE_LOCAL_USER_START",
  UPDATE_ASSASSIN = "UPDATE_ASSASSIN",
  UPDATE_DEAD = "UPDATE_DEAD",
  GAME_KILLER_FINISH = "GAME_KILLER_FINISH",
  YOU_KILL = "YOU_KILL",
  UPDATE_CROWN = "UPDATE_CROWN",
}

export enum SpaceSendMessageType {
  CHANGE_SPACE = "CHANGE_SPACE",
  UPDATE_SPACE = "UPDATE_SPACE",
  CONNECTED_USERS = "CONNECTED_USERS_SPACE",
  USER_ENDED_SESSION = "USER_ENDED_SESSION_SPACE",
  LABEL_TOGGLE = "LABEL_TOGGLE_SPACE",
  SPACE_DISABLED = "SPACE_DISABLED",
  WEBINAR_ACTIVE_ROOM_COLLIDER = "WEBINAR_ACTIVE_ROOM_COLLIDER",
  FOCUS_USER = "FOCUS_USER",
  UPDATE_ROOM = "UPDATE_ROOM",
  UPDATE_POSTER = "UPDATE_POSTER",
  UPDATE_MULTI_WEBINAR = "UPDATE_MULTI_WEBINAR",
  UPDATE_WALLS = "UPDATE_WALLS",
}

export enum SystemSendMessageType {
  INITIALIZE_USER_AND_SPACE = "INITIALIZE_USER_AND_SPACE_SYSTEM",
  FORCE_RESIZE = "FORCE_RESIZE",
  EXIT_NUBII = "EXIT_NUBII",
  INITIALIZE_USER_ONBOARDING = "INITIALIZE_USER_ONBOARDING",
  INITIALIZE_CITY = "INITIALIZE_CITY",
  UPDATE_PIN = "UPDATE_PIN",
  SET_ZOOM = "SET_ZOOM",
  SET_ROTATION = "SET_ROTATION",
  SET_MOVE_CAMERA = "SET_MOVE_CAMERA",
  SET_ROTATIOM_CAMERA = "SET_ROTATIOM_CAMERA",
  BEGIN_TUTORIAL = "BEGIN_TUTORIAL",
  UPDATE_USER_POSITION = "UPDATE_USER_POSITION",
  UPDATE_POSITION_BY_ROOM = "UPDATE_POSITION_BY_ROOM",
  IN_THE_ROOM = "IN_THE_ROOM",
}

export enum RoomCallType {
  NO_CALL = "NO_CALL",
  MEETING_ROOM = "MEETING_ROOM",
  WEBINAR = "WEBINAR",
}

/* RECEIVE MESSAGE FROM GRAPHIC CLIENT */
export enum UserReceiveMessageType {
  USER_GUEST_GO_TO_ROOM = "USER_GUEST_GO_TO_ROOM",
  USER_CONNECT_TO_ROOM_CALL = "USER_CONNECT_TO_ROOM_CALL",
  USER_CONNECT_TO_ROOM_NORMAL = "USER_CONNECT_TO_ROOM_NORMAL",
  USER_DISCONNECT_FROM_ROOM_CALL = "USER_DISCONNECT_FROM_ROOM_CALL",
  USER_DISCONNECT_FROM_ROOM_NORMAL = "USER_DISCONNECT_FROM_ROOM_NORMAL",
  USER_CALL_ONE_TO_ONE = "USER_CALL_ONE_TO_ONE",
  USER_CHAT_ONE_TO_ONE = "USER_CHAT_ONE_TO_ONE",
  USER_SHOW_USER_INFO = "USER_SHOW_USER_INFO",
  USER_SEND_PAPER_PLANE = "USER_SEND_PAPER_PLANE",
  USER_SAVE_POSITION = "USER_SAVE_POSITION",
  USER_GET_TIMEZONE_UTC_OFFSET = "USER_GET_TIMEZONE_UTC_OFFSET",
  USER_BAN = "USER_BAN",
  USER_CONNECT_TO_ROOM_AUTO_VIDEO = "USER_CONNECT_TO_ROOM_AUTO_VIDEO",
  USER_DISCONNECT_FROM_ROOM_AUTO_VIDEO = "USER_DISCONNECT_FROM_ROOM_AUTO_VIDEO",
}

export enum SpaceReceiveMessageType {
  SPACE_READY = "SPACE_READY",
  CREATE_WEBINAR = "CREATE_WEBINAR",
  CLOSE_WEBINAR = "CLOSE_WEBINAR",
  CHANGE_WEBINAR_VIDEO = "CHANGE_WEBINAR_VIDEO",
  SPACE_GRAPHIC_CLIENT_LOADING_PROGRESS = "SPACE_GRAPHIC_CLIENT_LOADING_PROGRESS",
}

export enum SystemReceiveMessageType {
  SYSTEM_GRAPHIC_CLIENT_LOAD_COMPLETE = "SYSTEM_GRAPHIC_CLIENT_LOAD_COMPLETE",
  SYSTEM_GRAPHIC_CLIENT_READY_EVENT = "SYSTEM_GRAPHIC_CLIENT_READY_EVENT",
  SYSTEM_GRAPHIC_CLIENT_OPEN_HELP_POINT = "SYSTEM_GRAPHIC_CLIENT_OPEN_HELP_POINT",
  SYSTEM_GRAPHIC_CLIENT_OPEN_WONDER_POINT = "SYSTEM_GRAPHIC_CLIENT_OPEN_WONDER_POINT",
  SYSTEM_GRAPHIC_CLIENT_OPEN_MENU_CHANGE_SPACE_AND_EXIT = "SYSTEM_GRAPHIC_CLIENT_OPEN_MENU_CHANGE_SPACE_AND_EXIT",
  SYSTEM_GRAPHIC_CLIENT_PHOTON_ERROR = "SYSTEM_GRAPHIC_CLIENT_PHOTON_ERROR",
  SYSTEM_GRAPHIC_SET_ZOOM = "SYSTEM_GRAPHIC_SET_ZOOM",
  SYSTEM_GRAPHIC_SET_MAX_ZOOM = "SYSTEM_GRAPHIC_SET_MAX_ZOOM",
  SYSTEM_GRAPHIC_SET_MIN_ZOOM = "SYSTEM_GRAPHIC_SET_MIN_ZOOM",
  SYSTEM_GRAPHIC_CLIENT_ONBOARDING_STEP_COMPLETED = "SYSTEM_GRAPHIC_CLIENT_ONBOARDING_STEP_COMPLETED",
  SYSTEM_DESCRIPTION_BOOTH_ACTIVE = "SYSTEM_DESCRIPTION_BOOTH",
  SYSTEM_DESCRIPTION_BOOTH_DISABLE = "SYSTEM_DESCRIPTION_BOOTH_DISABLE",
  SYSTEM_DESCRIPTION_BOOTH_CLICK = "SYSTEM_DESCRIPTION_BOOTH_CLICK",
  SYSTEM_UPDATE_USER_POSITION = "SYSTEM_UPDATE_USER_POSITION",
  WEBGL_CONTEXT_LOST = "WEBGL_CONTEXT_LOST",
  SYSTEM_LOAD_SUPER_SPACE = "SYSTEM_LOAD_SUPER_SPACE",
  SYSTEM_SHOW_PIN_INFO = "SYSTEM_SHOW_PIN_INFO",
  SYSTEM_HIDE_PIN_INFO = "SYSTEM_HIDE_PIN_INFO",
  SYSTEM_POSTER_ACTIVE = "SYSTEM_POSTER_ACTIVE",
  SYSTEM_POSTER_DISABLE = "SYSTEM_POSTER_DISABLE",
  SYSTEM_POSTER_CLICK = "SYSTEM_POSTER_CLICK",
  SYSTEM_GENERAL_ERROR = "SYSTEM_GENERAL_ERROR",
  SYSTEM_BIRTHDAY_ACTIVE = "SYSTEM_BIRTHDAY_ACTIVE",
  SYSTEM_ROBOT_ACTIVE = "SYSTEM_ROBOT_ACTIVE",
  SYSTEM_GAME_KILL = "SYSTEM_GAME_KILL",

}
